import imgMulti from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-1.jpg';
import imgKlasseZ from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-9.jpg';
import imgSnapchat from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-8.jpg';
import imgNavn from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-5.jpg';
import imgFlagPrint from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-7.jpg';
import imgSkolelogo from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-6.jpg';
import img3DSkolelogo from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-2.jpg';
import imgKlasseY from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-4.jpg';
import imgFlagBroderi from '../../../../assets/cls-dk/tryk-broderi/tryk-broderi-3.jpg';

export const TRYK_BRODERI_TITLE = 'Tryk & Broderi';

export const TRYK_BRODERI_ITEMS = [
  { id: 'multi',            name: 'Mulitfarvet tryk',           image: imgMulti },
  { id: 'klasse-tryk',      name: 'Klassebetegnelsestryk',      image: imgKlasseZ },
  { id: 'special',          name: 'Specieltryk',                image: imgSnapchat },
  { id: 'navn',             name: 'Navnetryk',                  image: imgNavn },
  { id: 'flag-tryk',        name: 'Flagtryk',                   image: imgFlagPrint },
  { id: 'skolelogo',        name: 'Skolelogo',                  image: imgSkolelogo },
  { id: '3d-skolelogo',     name: '3D skolelogo',                image: img3DSkolelogo },
  { id: 'klasse-broderi',   name: 'Klassebetegnelsesbroderi',    image: imgKlasseY },
  { id: 'flag-broderi',     name: 'Flagbroderi',                 image: imgFlagBroderi },
];
